import { formatDistanceToNow } from 'date-fns';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments } from '@fortawesome/free-solid-svg-icons';

export default function ResumeChatCard({ chat }) {
  const handleResume = () => {
    window.dispatchEvent(new CustomEvent('openChat', { detail: { conversationId: chat.id } }));
  };

  const getFirstMessage = () => {
    if (chat.messages && chat.messages.length > 0) {
      const firstUserMessage = chat.messages.find(m => m.role === 'user');
      if (firstUserMessage) {
        return firstUserMessage.content.substring(0, 80) + (firstUserMessage.content.length > 80 ? '...' : '');
      }
    }
    return 'Continue conversation';
  };

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2 }}
      onClick={handleResume}
      className="group bg-white rounded-2xl border border-border overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300"
    >
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <FontAwesomeIcon 
              icon={faComments} 
              className="text-primary text-2xl" 
            />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold text-primary uppercase tracking-wide">Resume Chat</span>
            <h3 className="font-serif font-bold text-lg text-text-primary line-clamp-1 group-hover:text-primary transition-colors mt-1">
              {chat.title || 'Conversation'}
            </h3>
          </div>
        </div>
        
        <p className="text-sm text-text-secondary line-clamp-2 mb-4">
          {getFirstMessage()}
        </p>
        
        <div className="flex items-center justify-between">
          {chat.updatedAt && (
            <div className="flex items-center gap-1 text-xs text-text-secondary">
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{formatDistanceToNow(chat.updatedAt.toDate ? chat.updatedAt.toDate() : new Date(chat.updatedAt), { addSuffix: true })}</span>
            </div>
          )}
          
          <span className="text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
            Resume
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </motion.div>
  );
}

